import { SaveLoginType } from '@upstart/harmony/lib/constants';

export const newLoginSchema = {
  title: 'CRM/Other Login configurations',
  type: 'object',
  required: ['login', 'password', 'type', 'dealer_id'],
  properties: {
    login: { type: 'string', title: 'Login' },
    password: { type: 'string', title: 'Password' },
    type: { type: 'string', title: 'Type', enum: Object.values(SaveLoginType) },
    dealer_id: { type: 'string' },
    isActive: { type: 'boolean', default: true },
  },
};

export const step1Schema = {
  title: 'CRM/Other Login configurations',
  type: 'object',
  required: ['login', 'type', 'dealer_id'],
  properties: {
    login: { type: 'string', title: 'Login' },
    password: { type: 'string', title: 'Password' },
    type: { type: 'string', title: 'Type', enum: Object.values(SaveLoginType) },
    dealer_id: { type: 'string' },
  },
};

export const uiSchema = {
  id: {
    'ui:readonly': true,
  },
  dealer_id: { 'ui:widget': 'hidden' },
  password: {
    'ui:widget': 'password',
    'ui:placeholder': '**********',
  },
  isActive: { 'ui:widget': 'hidden' },
};
